import {useCallback} from 'react';
import {useReservation} from 'context/reservation';
import {ORIGINS} from '@chekin/core';
import {useTaxes} from './taxes';
import {useGuestGroup} from './useGuestGroup';

function useReservationSettings() {
  const {seasonEntity} = useTaxes();
  const {allowEditingGuestNumber, data: reservation} = useReservation();
  const {areAllGuestsRegistered} = useGuestGroup();
  const hasReservationNumber = Boolean(reservation?.booking_reference);

  const showReservationNumberBox =
    reservation &&
    [ORIGINS.guesty, ORIGINS.guesty2].includes(reservation.origin) &&
    hasReservationNumber;

  const checkCanEditReservationDetails = useCallback(() => {
    const thereAreTaxRules = Boolean(seasonEntity?.rules && seasonEntity.rules.length);

    if (thereAreTaxRules) {
      return true;
    }

    return allowEditingGuestNumber;
  }, [allowEditingGuestNumber, seasonEntity]);

  const checkCanShowRegisterButton = useCallback(() => {
    return allowEditingGuestNumber || !areAllGuestsRegistered;
  }, [areAllGuestsRegistered, allowEditingGuestNumber]);

  return {
    checkCanEditReservationDetails,
    checkCanShowRegisterButton,
    showReservationNumberBox,
  };
}

export {useReservationSettings};
